//export const api = "https://localhost:44389/api/";
export const api = "https://www.bankbychoice.com:8080/api/";
export const apiUAT = "http://148.72.206.209:129/api/";
export const apiLocal = "https://localhost:44389/api/";
//export const apiDirect = "http://gulfoasisuat.uaenorth.cloudapp.azure.com:91/api/";
// export const api = "http://199.250.206.132:8080/api/";
//export const api = "http://148.72.206.209:129/api/";
// export const https = "http://localhost:3000";
export const https = "https://car.bankbychoice.com";
